module.exports = __webpack_public_path__ + "img/niki-sebi.2907fe50.jpg";